import axios from 'axios';
import {API_ADMIN_CHECK_PERMISSION} from './urlConstants';
import {handleHttpError} from './ErrorUtils';

export const isWafResponse = (response) => {
  return response.status === 405;
}

export const checkAdminPermission = (props) => {
  return new Promise((resolve, reject) => {
    axios
        .get(API_ADMIN_CHECK_PERMISSION)
        .catch(error => {
          handleHttpError(props.t, props.history, error);
          reject(error);
        })
  });
}

export const subtractDateByDay = (date, day) => {
    const reducedDate = new Date(date);
    reducedDate.setDate(reducedDate.getDate() - day);
    return reducedDate;
}

export const parseSearchValue = (searchValue) => {
    return searchValue ? searchValue : "";
}

export const convertSearchTextToCommaDelimiterString = (searchText) => {
    if (searchText && searchText !== "") {
        return searchText.split(",").filter(text => text !== "").join(",");
    }
    return "";
}

export const sortOptions = (obj1, obj2) => {
    if (obj1.label > obj2.label) {
        return 1;
    }
    if (obj1.label < obj2.label) {
        return -1;
    }
    return 0;
}

export const directDownload = (response) => {
    const filename = response.headers.filename;
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
}